module.exports = __webpack_public_path__ + "static/media/deductibleJ.c437733c.png";